import ApiService from "@/base/api/api.service"

import {
    GET_EXPLORE_LIST
} from "@/store/actions.type"

import {
    PUSH_EXPLORE_LIST,
    SET_ERROR
} from "@/store/mutations.type"

import {
    GET_POST_URL
} from "@/base/api/config";

const StateKey = 'exploreList'

export default {
    async [GET_EXPLORE_LIST]({ commit, state }) {
        try {
            const res = await ApiService.get(GET_POST_URL, 
              `list?offset=${state[StateKey + 'Offset']}&limit=${state[StateKey + 'Limit']}`)
            commit(PUSH_EXPLORE_LIST, res.data.posts)
        } catch (err) {
            commit(SET_ERROR, err.data)
        }
    }
}